import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ArcProxyState {
    arcId: string | null;
    arcProxyHost: string | null;
}

const arcProxySlice = createSlice({
    name: 'arcProxy',
    initialState: { arcId: null, arcProxyHost: null } as ArcProxyState,
    reducers: {
        setArcId: (state, action: PayloadAction<string | null>) => {
            state.arcId = action.payload;
        },
        setArcProxyHost: (state, action: PayloadAction<string | null>) => {
            state.arcProxyHost = action.payload;
        },
    },
});

export const { setArcId, setArcProxyHost } = arcProxySlice.actions;
export default arcProxySlice.reducer;
